import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaSave, FaCog, FaBell, FaShieldAlt, FaDatabase } from 'react-icons/fa';
import { toast } from 'react-toastify';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';

const AdminSettings = () => {
  const [settings, setSettings] = useState({
    siteName: 'Vivah Arambh',
    siteNameMarathi: 'विवाह आरंभ',
    maintenanceMode: false,
    registrationEnabled: true,
    emailNotifications: true,
    whatsappNotifications: false,
    autoApproveProfiles: false,
    maxPhotosPerUser: 5,
    freeProfileViews: 10,
    basicPlanPrice: 1000,
    premiumPlanPrice: 1500,
    royalPlanPrice: 2000
  });

  const handleChange = (key, value) => {
    setSettings(prev => ({ ...prev, [key]: value }));
  };

  const handleSave = () => {
    toast.success('Settings saved successfully');
  };

  const Section = ({ icon: Icon, title, titleMarathi, children }) => (
    <div className="bg-white rounded-xl shadow-md p-6 mb-6">
      <div className="flex items-center gap-3 mb-4 pb-3 border-b border-gray-200">
        <Icon className="text-xl text-[#8B0000]" />
        <div>
          <h3 className="text-lg font-semibold text-[#8B0000]">{title}</h3>
          <p className="text-sm text-gray-500 font-['Noto_Sans_Devanagari']">{titleMarathi}</p>
        </div>
      </div>
      <div className="space-y-4">{children}</div>
    </div>
  );

  const Toggle = ({ label, description, value, onChange }) => (
    <div className="flex items-center justify-between py-2">
      <div>
        <p className="font-medium text-gray-700">{label}</p>
        {description && <p className="text-sm text-gray-400">{description}</p>}
      </div>
      <button
        onClick={() => onChange(!value)}
        className={`relative w-12 h-6 rounded-full transition-colors ${value ? 'bg-[#8B0000]' : 'bg-gray-300'}`}
      >
        <span className={`absolute top-0.5 w-5 h-5 rounded-full bg-white shadow transition-transform ${value ? 'left-6' : 'left-0.5'}`} />
      </button>
    </div>
  );

  return (
    <>
      <Navbar />
      <div className="min-h-screen bg-[#FFF8F0] pt-20 pb-12">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/admin" className="text-[#8B0000] hover:underline flex items-center gap-1 text-sm mb-2">
            <FaArrowLeft /> Back to Dashboard
          </Link>
          <div className="flex items-center justify-between mb-6">
            <div>
              <h1 className="text-3xl font-bold text-[#8B0000] font-['Playfair_Display']">Settings</h1>
              <p className="text-gray-600 font-['Noto_Sans_Devanagari']">सेटिंग्ज</p>
            </div>
            <button onClick={handleSave} className="px-4 py-2 bg-[#8B0000] text-white rounded-lg hover:bg-[#6B0000] flex items-center gap-2">
              <FaSave /> Save Changes
            </button>
          </div>

          <Section icon={FaCog} title="General" titleMarathi="सामान्य सेटिंग्ज">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm text-gray-600 mb-1">Site Name</label>
                <input type="text" value={settings.siteName} onChange={e => handleChange('siteName', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-[#8B0000]" />
              </div>
              <div>
                <label className="block text-sm text-gray-600 mb-1">Site Name (Marathi)</label>
                <input type="text" value={settings.siteNameMarathi} onChange={e => handleChange('siteNameMarathi', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-[#8B0000]" />
              </div>
            </div>
            <Toggle label="Maintenance Mode" description="Disable site for all non-admin users" value={settings.maintenanceMode} onChange={v => handleChange('maintenanceMode', v)} />
            <Toggle label="Registration Enabled" description="Allow new user registrations" value={settings.registrationEnabled} onChange={v => handleChange('registrationEnabled', v)} />
          </Section>

          <Section icon={FaBell} title="Notifications" titleMarathi="सूचना सेटिंग्ज">
            <Toggle label="Email Notifications" description="Send email notifications for matches and interests" value={settings.emailNotifications} onChange={v => handleChange('emailNotifications', v)} />
            <Toggle label="WhatsApp Notifications" description="Send WhatsApp messages for important updates" value={settings.whatsappNotifications} onChange={v => handleChange('whatsappNotifications', v)} />
          </Section>

          <Section icon={FaShieldAlt} title="Verification" titleMarathi="पडताळणी सेटिंग्ज">
            <Toggle label="Auto-approve Profiles" description="Automatically approve new profiles without manual review" value={settings.autoApproveProfiles} onChange={v => handleChange('autoApproveProfiles', v)} />
            <div>
              <label className="block text-sm text-gray-600 mb-1">Max Photos Per User</label>
              <input type="number" value={settings.maxPhotosPerUser} onChange={e => handleChange('maxPhotosPerUser', parseInt(e.target.value))} className="w-32 px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-[#8B0000]" />
            </div>
          </Section>

          <Section icon={FaDatabase} title="Subscription Pricing" titleMarathi="सदस्यता किंमत">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {[
                { label: 'Basic Plan (₹)', key: 'basicPlanPrice' },
                { label: 'Premium Plan (₹)', key: 'premiumPlanPrice' },
                { label: 'Royal Plan (₹)', key: 'royalPlanPrice' }
              ].map(item => (
                <div key={item.key}>
                  <label className="block text-sm text-gray-600 mb-1">{item.label}</label>
                  <input type="number" value={settings[item.key]} onChange={e => handleChange(item.key, parseInt(e.target.value))} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-[#8B0000]" />
                </div>
              ))}
            </div>
            <div>
              <label className="block text-sm text-gray-600 mb-1">Free Profile Views / Month</label>
              <input type="number" value={settings.freeProfileViews} onChange={e => handleChange('freeProfileViews', parseInt(e.target.value))} className="w-32 px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-[#8B0000]" />
            </div>
          </Section>

          <div className="text-center">
            <button onClick={handleSave} className="px-8 py-3 bg-[#8B0000] text-white rounded-lg hover:bg-[#6B0000] font-semibold flex items-center gap-2 mx-auto">
              <FaSave /> Save All Settings
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AdminSettings;
